import ExperienceList from "./ExperienceList/ExperienceList";

import styles from "./ExperiencePresentation.module.scss";

const ExperiencePresentation = ({ url, currency, serverState }) => {
  return (
    <div className={`${styles.experiencesFront}`}>
      <ExperienceList url={url} currency={currency} serverState={serverState} />
    </div>
  );
};

export default ExperiencePresentation;
